// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"7af18b60","307":"8fdf6b7c","524":"b4258098","548":"ba0e9618","589":"13425edb","716":"3fecffac","845":"e43f7879"}[chunkId] + ".chunk.js";
};